<template>
    <div>
        <Loading v-if="isLoading"
                 v-model:active="isLoading"
                 loader="bars"
                 :height="55"
                 :width="55"
                 :z-index="9999"
                 :can-cancel="false"
                 :is-full-page="fullPage"
                 color="darkred" />
        <vue-notification-list position="top-right" />
        <router-view />
    </div>
</template>

<script>

    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'App',
        components: {
            Loading,
        },
        data() {
            return {
                isLoading: false,
                fullPage: true
            }
        },
        created() {
            let $this = this;

            axios.interceptors.request.use((config) => {
                if (config.notLoading != true && !$this.isLoading) {
                    $this.isLoading = true;
                }
                return config;
            }, (error) => {
                if ($this.isLoading) { $this.isLoading = false; }
                return Promise.reject(error);
            });
            axios.interceptors.response.use((response) => {
                if ($this.isLoading) { $this.isLoading = false; }
                return response;
            }, (error) => {
                if ($this.isLoading) { $this.isLoading = false; }
                return Promise.reject(error);
            });
        },
    }

</script>

<style scoped>
    .notification-list {
        z-index: 9999 !important;
    }
</style>